import clearableInputView from './clearableInputView.html';
import './clearableInputStyles.css';

export function clearableInputComponent() {
	return {
		bindings: {
			model: '=',
			modelOptions: '<?',
			onEnter: '&?',
			onKeyup: '&?',
			onClear: '&?',
			placeholder: '@',
			isSearch: '<?',
			size: '<?',
			disabled: '<?',
		},
		controllerAs: 'vm',
		controller: clearableInputComponentCtrl,
		template: clearableInputView,
	};
}

export class clearableInputComponentCtrl {
	constructor($element) {
		'ngInject';
		// save element so we can focus on input
		this.$element = $element;
	}

	keyup(evt) {
		if (evt.which == 13) {
			this.onEnter && this.onEnter();
		}
		this.onKeyup && this.onKeyup({ $event: evt });
	}

	clear() {
		this.model = '';
		try {
			this.$element.find('input')[0].focus();
		} catch (e) {}
		this.onClear && this.onClear();
	}
}
